/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const activityGroupDtoSchema = z.object({
  date: z.string().date().nullable(),
  year: z.coerce.number().int().nullable(),
  month: z.coerce.number().int().nullable(),
  employeeValue: z.coerce.number().int().nullable(),
  employeeLabel: z.coerce.string().nullable(),
  projectValue: z.coerce.number().int().nullable(),
  projectLabel: z.coerce.string().nullable(),
  macroProjectValue: z.coerce.number().int().nullable(),
  macroProjectLabel: z.coerce.string().nullable(),
  costCenterLabel: z.coerce.string().nullable(),
  costCenterValue: z.coerce.number().int().nullable(),
  clientLabel: z.coerce.string().nullable(),
  clientValue: z.coerce.number().int().nullable(),
  effectiveHours: z.coerce.number().optional(),
});
